import { useState } from 'react';

import { getStorageValue, setStorageValue } from '@helpers/storage';
import { StorageValues, StorageTypes } from '@interfaces/storage';

import { EAudioPlaybackType } from '@core/assistant/interfaces';
import { greetingsScript } from '@core/assistant/greetingsScript';

import { SocketEventRequestType, SocketEventDirection } from './interfaces';
import { socket } from './Socket';
import { useUserName } from './UserName';
import { shared } from './Shared';
import { log } from './Debug';
import { AudioVisualizer, visualizeAudio } from './AudioVisualizer';
import { assistantSize } from '@core/assistant/constants';
import AssistantQueryService from '@services/AssistantQueryService';

export const useGreetings = () => {
  const userName = useUserName();
  const [isGreetingsPlayback, setIsGreetingsPlayback] = useState(false);

  const generateGreetingsAudio = async (isFirstTimeLogin?: boolean) => {
    shared.audioPlayBackType = EAudioPlaybackType.GREETINGS;
    log('generateGreetingsAudio clicked');

    const pollyResponse = await AssistantQueryService.generateAssistantAudio({
      text: 'Hello, I am Noa, your AI assistant' /*(isFirstTimeLogin
        ? greetingsScript.first
        : greetingsScript.second
      ).replace('{{userName}}', userName ? ', ' + userName : '')*/,
      disableOptimizations: true,
    });

    console.warn('polly response', pollyResponse);

    if (pollyResponse.audio) {
      const arrayBuffer = AudioVisualizer.toArrayBuffer(pollyResponse.audio);
      let visualizerInstance: any;

      if (visualizerInstance) {
        visualizerInstance.stopAudio();
      }
      visualizerInstance = visualizeAudio(
        assistantSize.width,
        assistantSize.height,
        () => {},
      );
      visualizerInstance = visualizerInstance.initialize(arrayBuffer);
    } else {
      console.warn('Error: missing Polly audio');
    }
  };

  const playBackOnFirstTime = () => {
    log('playBackOnFirstTime');

    const assistantStorage = getStorageValue<any>(StorageValues.Assistant) || {
      isFirstTime: true,
    };

    if (assistantStorage.isFirstTime) {
      setIsGreetingsPlayback(true);

      setStorageValue(StorageValues.Assistant, {
        isFirstTime: false,
      });

      generateGreetingsAudio(true);
    }

    // TEMP fix for auditorium exit button issue
    // when assistant 2nd login greetinggs is replayed
    // TODO: proper fix
    const assistantStorageSession = getStorageValue<any>(
      StorageValues.Assistant,
      StorageTypes.Session,
    ) || {
      isGreetingsPlayed: false,
    };

    if (!assistantStorageSession.isGreetingsPlayed) {
      setIsGreetingsPlayback(true);

      log('setIsGreetingsPlayback');

      // lets keep it
      /*setLocalStorageValue(
        StorageValues.Assistant,
        {
          ...assistantStorageSession,
          isGreetingsPlayed: true,
        },
        'session',
      );*/

      generateGreetingsAudio(false);
    }
  };

  return {
    generateGreetingsAudio,
    playBackOnFirstTime,
    isGreetingsPlayback,
    setIsGreetingsPlayback,
  };
};
